// @ts-ignore
import getCenter from '@turf/center';
import {IContactNode, IFeature, IFeature_CONO} from '../types';
import {getFormattedDate, getFormattedDateUserReadable} from './getFormattedDate';

// export type IPopupInfo = ReturnType<typeof getPopupInfo> & {[key:string]: any}

export interface IPopupInfo { [p: string]: any; datelastchanged: string | undefined; descriptionLabels: string[];
    fullUid: string | undefined; latitude: number; description: Array<string | string>; membertype: string | number;
    title: string | undefined; type: string | undefined; descriptionKeys: string[]; readOnlyKeys: string[];
    feature: IFeature_CONO; websiteurl: string; name: string; id: string | undefined; contacts: IContactNode[];
    longitude: number; }

/*
*
*
* Layer Name (✔)
* Name (✔)
* Member Type
* Website
* Contacts Box,
* Noxes
* Instructions
* Date Last Changed
*
*
* **/

export function getPopupInfo(feature: IFeature) {
    const descriptionKeys = ['datelastchanged'];
    const popupLabels = ['Date Last Changed'];
    const readOnlyKeys = ['Date Last Changed'];
    const coordinates = getCenter(feature.geometry as any).geometry!.coordinates;
    const latitude = coordinates[1];
    const longitude = coordinates[0];

    feature.properties = {
        ...feature.properties,
        'Member Type': feature.properties.membertype,
        'Jurisdiction': feature.properties.notes,
        // ['Instructions']: feature.properties.instruc,
        'Date Last Changed': `${getFormattedDateUserReadable(
            feature.properties.datelastchanged!,
        )} (${getFormattedDate(feature.properties.datelastchanged!)})`,
    };

    const {
        name,
        membertype,
        address,
        city,
        state,
        zip,
        websiteurl,
        email,
        phone,
        fullUid,
        type,
        notes,
        datelastchanged,
    } = feature.properties;
    const id = feature.properties.fullUid;
    const title = feature.properties.layername || feature.properties.type;
    const descriptionLabels = Object.keys(feature.properties)
        .filter(k => popupLabels.indexOf(k) !== -1);
    const description = descriptionLabels
        .map(k => feature.properties[k] ? `${feature.properties[k]}` : '');

    const contacts = feature.properties.contacts;

    return {
        id,
        fullUid,
        title,
        type,
        name,
        membertype,
        address,
        city,
        state,
        zip,
        notes,
        datelastchanged,
        websiteurl,
        phone,
        email,
        contacts,
        description,
        descriptionLabels,
        descriptionKeys, // map description keys from labels
        readOnlyKeys,
        latitude,
        longitude,
        feature,
    };
}
